export const BOLD = "Bowled";
export const CATCH = "Catch";
export const STUMP = "Stump";
export const HIT_WICKET = "Hit Stump";
export const RUN_OUT = "Run Out";
